import { render } from "./Content_process.vue?vue&type=template&id=6768bb78&scoped=true"
import script from "./Content_process.vue?vue&type=script&lang=js"
export * from "./Content_process.vue?vue&type=script&lang=js"

import "./Content_process.vue?vue&type=style&index=0&id=6768bb78&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6768bb78"]])